import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存");

import { ref, computed, watch, onMounted } from 'vue';
import { getVexTableProps } from '@/config';
import { getDistributorList } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'SelectDistributorListModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierCategory: {
      type: Number,
      default: 1
    },
    dictList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const defaultForm = {
      branchName: '',
      businessScop: [],
      supplierCategory: '1'
    };
    const form = ref(_objectSpread({}, defaultForm));
    const table = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        form.value = _objectSpread({}, defaultForm);
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });

    function reset() {
      form.value = _objectSpread({}, defaultForm);
      table.value.commitProxy('reload');
    }

    function confirm() {
      const selectRows = table.value.getCheckboxRecords().concat(table.value.getCheckboxReserveRecords());

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      visible.value = false;
      emit('success', selectRows);
      table.value.clearCheckboxReserve();
      table.value.clearCheckboxRow();
    } // 发货方表格列


    const distributorCol = [{
      type: 'checkbox',
      width: '50px',
      fixed: 'left'
    }, {
      title: '发货方编号',
      field: 'branchId',
      width: '200px',
      showOverflow: true
    }, {
      title: '发货方名称',
      field: 'branchName',
      width: '150px',
      showOverflow: true
    }, {
      title: '业务区域',
      field: 'businessArea',
      width: '150px',
      showOverflow: true
    }, {
      title: '详细地址',
      field: 'address',
      width: '250px',
      showOverflow: true
    }, {
      title: '联系人',
      field: 'linkMan',
      width: '200px',
      showOverflow: true
    }, {
      title: '联系人电话',
      field: 'linkTel',
      width: '150px',
      showOverflow: true
    }]; // 厂家表格列

    const manufactorCol = [{
      type: 'checkbox',
      width: '50px',
      fixed: 'left'
    }, {
      title: '厂家编号',
      field: 'branchId',
      width: '200px',
      showOverflow: true
    }, {
      title: '厂家名称',
      field: 'branchName',
      width: '150px',
      showOverflow: true
    }, {
      title: '详细地址',
      field: 'address',
      width: '250px',
      showOverflow: true
    }, {
      title: '联系人',
      field: 'linkMan',
      width: '200px',
      showOverflow: true
    }, {
      title: '联系人电话',
      field: 'linkTel',
      width: '150px',
      showOverflow: true
    }];

    function loadTableColumns() {
      var _table$value2;

      (_table$value2 = table.value) === null || _table$value2 === void 0 ? void 0 : _table$value2.loadColumn(props.supplierCategory === 1 ? manufactorCol : distributorCol);
    } // 切换表格列显示


    watch(() => props.supplierCategory, newVal => {
      loadTableColumns();
    });
    const tableOptions = getVexTableProps({
      checkboxConfig: {
        reserve: true
      },
      rowConfig: {
        keyField: 'branchId'
      },
      pagerConfig: {
        pageSize: 5
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getDistributorList(_objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value), {}, {
              supplierCategory: props.supplierCategory,
              businessScop: form.value.businessScop.join(',')
            })).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: props.supplierCategory === 1 ? '厂家信息' : '发货方信息',
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: props.supplierCategory === 1 ? '厂家信息' : '发货方名称'
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.branchName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.branchName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [props.supplierCategory !== 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "业务区域"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.businessScop,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.businessScop = $event),
                multiple: "",
                "collapse-tags": ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dictList, dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: dict.text,
                    value: dict.id,
                    key: dict.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "primary",
              icon: "Refresh",
              onClick: reset
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          onVnodeMounted: loadTableColumns
        }, _unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), null, 16)]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }

};